module.exports = __webpack_public_path__ + "img/dg.464d312b.svg";